import { Form, Spin, Tooltip } from 'antd'
import Button from 'components/Button'
import Checkbox from 'components/Checkbox/Checkbox'
import Control from 'components/Control/Control'
import Date from 'components/Date/Date'
import AntdInput from 'components/Form/Input'
import AntdSelect from 'components/Form/Select'
import Label from 'components/Label/Label'
import { ExclamationCircleFilled } from '@ant-design/icons'
import styled from 'styled-components'
import { setResumeData } from 'modules/Onboarding/actions'
import Address from 'modules/Onboarding/Register/PersonalInfo/Address'
import {
  Hobbies,
  Languages,
} from 'modules/Resume/DrawerComponents/AdditionalDetails/AdditionInfoInput'
import { genderOptions } from 'modules/Resume/DrawerComponents/AdditionalDetails/Constant'
import {
  FormItem,
  Heading,
  Text,
} from 'modules/Resume/DrawerComponents/AdditionalDetails/style'
import {
  AdjustIcon,
  FooterFlex,
  StyledDrawer,
} from 'modules/Resume/DrawerComponents/DrawerStyle'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { IsValidEmail } from 'utils/emailValidation'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import RichEditor from 'components/RichEditor/index'
import { updateCurrentState } from '../../../Onboarding/actions'
import AddIcon from 'components/icons/AddIcon'
import instituteRequest from 'utils/instituteRequest'

const PendingIcon = styled(ExclamationCircleFilled)`
  color: #eb5d60;
  font-size: 14px;
  margin-left: 6px;
  position: relative;
  top: -5px;
`

const LabelWithPending = ({ children, isPending }) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
    <Label>{children}</Label>
    {isPending && (
      <Tooltip title="Data Verification Pending">
        <PendingIcon />
      </Tooltip>
    )}
  </div>
)

const countRichTextCharacters = richText => {
  // Remove HTML tags using a regular expression
  const plainText = richText?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, ' ')

  // Count the characters in the plain text
  const characterCount = plainText?.length || 0 // Set to 0 if undefined

  return characterCount
}
const AdditionDrawer = ({
  drawerStatus,
  setdrawerStatus,
  updateStudentData,
  getPendingData,
  countryList,
  getListOfCountries,
  getListOfState,
  getListOfCity,
  getCities,
  studentFormData,
  pendingData,
}) => {
  const pendingFields = pendingData?.studentPersonalProfile?._pendingFields || {}
  const dateFormat = 'DD/MM/YYYY'
  const [form] = Form.useForm()
  const [error, setError] = useState('')
  const formRef = React.createRef()
  const dispatch = new useDispatch()

  const [gender, setGender] = useState('')
  const [date, setDate] = useState()
  const [casteValue, setCasteValue] = useState('')
  const [religionValue, setReligionValue] = useState('')
  const [perfCityList, setPerfCityList] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingState, setLoadingState] = useState(false)
  const [loadingCountry, setLoadingCountry] = useState(false)
  const [loadingCity, setLoadingCity] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  
  const [permStateList, setPermStateList] = useState([])
  const [permCityList, setPermCityList] = useState([])
  const [permCountryName, setPermCountryName] = useState('')
  const [permStateName, setPermStateName] = useState('')
  const [permCityName, setPermCityName] = useState('')
  const [permCountryId, setPermCountryId] = useState('')
  const [permStateId, setPermStateId] = useState('')
  const [permCityId, setPermCityId] = useState('')

  const [temStateList, setTemStateList] = useState([])
  const [temCityList, setTemCityList] = useState([])
  const [temCountryName, setTemCountryName] = useState('')
  const [temStateName, setTemStateName] = useState('')
  const [temCityName, setTemCityName] = useState('')
  const [temCountryId, setTemCountryId] = useState('')
  const [temStateId, setTemStateId] = useState('')
  const [temCityId, setTemCityId] = useState('')
  const [errorNote, setErrorNote] = useState('')
  const [searchCountry, setSearchCountry] = useState('')
  const [allOptions, setAllOptions] = useState([])
  const [isSameAddress, setIsSameAddress] = useState(
    studentFormData?.studentPersonalProfile?.isSameCorresponding
  )
  const [isPhysicallyChallenged, setIsPhysicallyChallenged] = useState(
    studentFormData?.studentPersonalProfile?.isPhysicallyChallenged
  )
  const [isAnyWhere, setIsAnyWhere] = useState(
    studentFormData?.studentPersonalProfile?.isAnywhere
  )

  const permAddressLine1 = Form.useWatch('permAddrLine1', form)
  const permAddressLine2 = Form.useWatch('permAddrLine2', form)
  const permPinCode = Form.useWatch('permPostCode', form)

  const [isUpdateButtonEnabled, setIsUpdateButtonEnabled] = useState(true)

  const [languages, setLanguages] = useState([
    {
      component: Languages,
      type: 'language_0',
    },
  ])

  const [hobbies, setHobbies] = useState([
    {
      component: Hobbies,
      type: 'hobbie_0',
    },
  ])

  const [extraCurriculars, setExtraCurriculars] = useState(
    pendingFields.extraCurriculars?.value || studentFormData?.studentPersonalProfile?.extraCurriculars
  )
  const [tpoConfig, setTpoConfig] = useState(null)
  const [frozenFields, setFrozenFields] = useState({})
  const RadioOptions = [
    {
      id: 1,
      label: 'Yes',
      value: true,
    },
    {
      id: 2,
      label: 'No',
      value: false,
    },
  ]
  let getStateData = async (countryId, isSate, search) => {
    if (countryId) {
      let list = await getListOfState(countryId, search, false, setLoadingState)
      return isSate ? setPermStateList(list || []) : setTemStateList(list || [])
    }
  }

  let getCityData = async (countryId, stateId, isSate, search) => {
    if (countryId && stateId) {
      let list = await getListOfCity(
        countryId,
        stateId,
        search,
        false,
        setLoadingCity
      )

      return isSate ? setPermCityList(list || []) : setTemCityList(list || [])
    }
  }
  let getPerfCityData = async search => {
    let list = await getCities(search)
    setSearchValue(search)
    const newOptions = [
      ...list?.cities?.map(city => ({
        value: city?.city_id,
        label: city?.city_name,
        type: 'city',
        payload: city,
      })),
      ...list?.states?.map(state => ({
        value: state?.state_id,
        label: state?.state_name,
        type: 'state',
        payload: state,
      })),
    ]

    setAllOptions(newOptions)
  }

  const [hobbieList, setHobbieList] = useState([])
  const [languageList, setLanguageList] = useState([])
  const [locations, setLocations] = useState([])
  const [inititalLocations, setInititalLocations] = useState([])

  const validateDateOfBirth = dateString => {
    const date = moment(dateString, 'DD/MM/YYYY', true)
    return date.isValid()
  }

  const handleDateChange = (date, dateString) => {
    setIsUpdateButtonEnabled(false)
    const isValidDate = validateDateOfBirth(dateString)
    if (!isValidDate) {
      form.setFieldsValue({ dob: null })
      setDate('')
      setError('Please enter a valid date of birth (DD/MM/YYYY)')
    }
    if (isValidDate) {
      setDate(moment(moment(dateString, 'DD/MM/YYYY').format('YYYY-MM-DD')))
      form.setFieldsValue({ dob: dateString })
      setError('')
    }
  }

  const onChangeGender = data => {
    setIsUpdateButtonEnabled(false)
    form.setFieldsValue({ gender: data })
    setGender(data)
  }
  const onChangeCaste = value => {
    setIsUpdateButtonEnabled(false)
    setCasteValue(value)
    form.setFieldsValue({
      caste: value,
    })
  }
  const onChangeReligion = value => {
    setIsUpdateButtonEnabled(false)
    setReligionValue(value)
    form.setFieldsValue({
      religion: value,
    })
  }
  const onChangeExtraCurriculars = value => {
    setIsUpdateButtonEnabled(false)
    form.setFieldsValue({
      extraCurriculars: value,
    })
    setExtraCurriculars(value)
  }

  useEffect(() => {
    let getData
    getData = setTimeout(() => {
      getListOfCountries(searchCountry, false, setLoading)
    }, 500)
    return () => clearTimeout(getData)
  }, [searchCountry])

  useEffect(() => {
    let personalData = studentFormData?.studentPersonalProfile
     let dob = pendingFields.dob?.value || studentFormData?.admin?.dob
     let formattedDOB

      if (dob && moment(dob, moment.ISO_8601, true).isValid()) {
           formattedDOB = moment(dob).format('YYYY-MM-DD') // or any other desired format
         } else {
           formattedDOB = '' // Return empty string if dob is not a valid date
         }

    if (studentFormData?.admin?.dob !== undefined) {
      form.setFieldsValue({
        dob: formattedDOB ?? '',
        gender: pendingFields.gender?.value || studentFormData?.studentPersonalProfile?.gender,
        secondaryEmail: studentFormData?.studentPersonalProfile?.secondaryEmail,
        permAddrLine1: pendingFields.permAddrLine1?.value || personalData?.permAddrLine1,
        permAddrLine2: pendingFields.permAddrLine2?.value || personalData?.permAddrLine2,
        permCountry: pendingFields.permCountry?.value || personalData?.permCountry,
        permPostCode: pendingFields.permPostCode?.value || personalData?.permPostCode,
        permCity: pendingFields.permCity?.value || personalData?.permCity,
        permState: pendingFields.permState?.value || personalData?.permState,
        permCityId: pendingFields.permCity?.permCityId || personalData?.permCityId,
        permStateId: pendingFields.permState?.permStateId || personalData?.permStateId,
        permCountryId: pendingFields.permCountry?.permCountryId || personalData?.permCountryId,
        corrAddrLine1: pendingFields.corrAddrLine1?.value || personalData?.corrAddrLine1,
        corrAddrLine2: pendingFields.corrAddrLine2?.value || personalData?.corrAddrLine2,
        corrCountry: pendingFields.corrCountry?.value || personalData?.corrCountry,
        corrPostCode: pendingFields.corrPostCode?.value || personalData?.corrPostCode,
        corrCity: pendingFields.corrCity?.value || personalData?.corrCity,
        corrState: pendingFields.corrState?.value || personalData?.corrState,
        corrCountryId: pendingFields.corrCountry?.corrCountryId || personalData?.corrCountryId,
        corrCityId: pendingFields.corrCity?.corrCityId || personalData?.corrCityId,
        corrStateId: pendingFields.corrState?.corrStateId || personalData?.corrStateId,
        isPhysicallyChallenged:
          studentFormData?.studentPersonalProfile?.isPhysicallyChallenged,
        physicalChallenge: personalData?.physicalChallenge,
        isAnywhere: personalData?.isAnywhere,
        extraCurriculars: pendingFields.extraCurriculars?.value || personalData?.extraCurriculars || '',
      })
      setExtraCurriculars(pendingFields.extraCurriculars?.value || personalData?.extraCurriculars || '')
    }

    setDate(formattedDOB)
    setGender(pendingFields.gender?.value || studentFormData?.studentPersonalProfile?.gender)
    setPermCountryName(pendingFields.permCountry?.value || personalData?.permCountry)
    setPermCityName(pendingFields.permCity?.value || personalData?.permCity)
    setPermStateName(pendingFields.permState?.value || personalData?.permState)
    setTemCountryName(pendingFields.corrCountry?.value || personalData?.corrCountry)
    setTemStateName(pendingFields.corrState?.value || personalData?.corrState)
    setTemCityName(pendingFields.corrCity?.value || personalData?.corrCity)
    const finalPermCountryId = pendingFields.permCountry?.permCountryId || personalData?.permCountryId
    const finalPermStateId = pendingFields.permState?.permStateId || personalData?.permStateId
    const finalPermCityId = pendingFields.permCity?.permCityId || personalData?.permCityId
    const finalCorrCountryId = pendingFields.corrCountry?.corrCountryId || personalData?.corrCountryId
    const finalCorrStateId = pendingFields.corrState?.corrStateId || personalData?.corrStateId
    const finalCorrCityId = pendingFields.corrCity?.corrCityId || personalData?.corrCityId
    const finalIsSameCorresponding = pendingFields.isSameCorresponding?.value ?? personalData?.isSameCorresponding
    
    setIsSameAddress(finalIsSameCorresponding)
    getStateData(finalPermCountryId, true)
    getCityData(finalPermCountryId, finalPermStateId, true)
    getPerfCityData('')

    if (!finalIsSameCorresponding) {
      getStateData(finalCorrCountryId, false)
      getCityData(finalCorrCountryId, finalCorrStateId, false)
    }

    setPermCountryId(finalPermCountryId)
    setPermStateId(finalPermStateId)
    setPermCityId(finalPermCityId)
    setTemCountryId(finalCorrCountryId)
    setTemStateId(finalCorrStateId)
    setTemCityId(finalCorrCityId)
  }, [studentFormData])

  useEffect(() => {
    const fetchTpoConfig = async () => {
      try {
        const instituteCampusId = studentFormData?.student?.instituteCampusId
        if (instituteCampusId) {
          const response = await instituteRequest.get(
            `/institutes/${instituteCampusId}/tpo-approval-config`
          )
          if (response?.data?.data) {
            setTpoConfig(response.data.data)
          }
        }
      } catch (error) {
        console.error('Error fetching TPO config:', error)
      }
    }
    fetchTpoConfig()
  }, [studentFormData?.student?.instituteCampusId])

  useEffect(() => {
    // Use TPO config for freezing fields
    let config = tpoConfig
    if (!config || !config.tpoApprovalConfig || !config.tpoApprovalConfig.fields || !config.isRequestForTPOApproval) {
      setFrozenFields({})
      return
    }
    const frozen = {}
    const fields = config.tpoApprovalConfig.fields
    
    const admin = studentFormData?.admin || {}
    const personalProfile = studentFormData?.studentPersonalProfile || {}
    
    const fieldMappings = {
      'firstName': { source: admin, key: 'firstName', configKey: 'firstName' },
      'lastName': { source: admin, key: 'lastName', configKey: 'lastName' },
      'dob': { source: admin, key: 'dob', configKey: 'dob' },
      'email': { source: admin, key: 'email', configKey: 'email' },
      'phoneNumber': { source: admin, key: 'phoneNumber', configKey: 'phoneNumber' },
      'gender': { source: personalProfile, key: 'gender', configKey: 'gender' },
      'secondaryEmail': { source: personalProfile, key: 'secondaryEmail', configKey: 'secondaryEmail' },
      'caste': { source: personalProfile, key: 'caste', configKey: 'caste' },
      'religion': { source: personalProfile, key: 'religion', configKey: 'religion' },
      'isPhysicallyChallenged': { source: personalProfile, key: 'isPhysicallyChallenged', configKey: 'isPhysicallyChallenged' },
      'physicalChallenge': { source: personalProfile, key: 'physicalChallenge', configKey: 'physicalChallenge' },
      'permAddrLine1': { source: personalProfile, key: 'permAddrLine1', configKey: 'permAddrLine1' },
      'permAddrLine2': { source: personalProfile, key: 'permAddrLine2', configKey: 'permAddrLine2' },
      'permCountry': { source: personalProfile, key: 'permCountry', configKey: 'permCountry' },
      'permState': { source: personalProfile, key: 'permState', configKey: 'permState' },
      'permCity': { source: personalProfile, key: 'permCity', configKey: 'permCity' },
      'permPostCode': { source: personalProfile, key: 'permPostCode', configKey: 'permPostCode' },
      'corrAddrLine1': { source: personalProfile, key: 'corrAddrLine1', configKey: 'corrAddrLine1' },
      'corrAddrLine2': { source: personalProfile, key: 'corrAddrLine2', configKey: 'corrAddrLine2' },
      'corrCountry': { source: personalProfile, key: 'corrCountry', configKey: 'corrCountry' },
      'corrState': { source: personalProfile, key: 'corrState', configKey: 'corrState' },
      'corrCity': { source: personalProfile, key: 'corrCity', configKey: 'corrCity' },
      'corrPostCode': { source: personalProfile, key: 'corrPostCode', configKey: 'corrPostCode' },
      'preferredJobLocation': { source: personalProfile, key: 'preferredJobLocation', configKey: 'preferredJobLocation' },
      'extraCurriculars': { source: personalProfile, key: 'extraCurriculars', configKey: 'extraCurriculars' },
      'languages': { source: personalProfile, key: 'languages', configKey: 'languages' },
      'hobbies': { source: personalProfile, key: 'hobbies', configKey: 'hobbies' },
      'cvUrl': { source: studentFormData?.resume, key: 'cvUrl', configKey: 'cvUrl' }
    }

    Object.entries(fieldMappings).forEach(([uiField, config]) => {
      const fullFieldName = config.configKey
      const fieldConfig = fields[fullFieldName]

      if (fieldConfig && fieldConfig.freezeAfterVerification) {
        const fieldValue = config.source[config.key]
        const hasValue = fieldValue !== null && fieldValue !== undefined && fieldValue !== '' && 
                         (!Array.isArray(fieldValue) || fieldValue.length > 0)
        
        const isPending = pendingFields[uiField] !== undefined
        
        if (hasValue && !isPending) {
          frozen[uiField] = true
          // Also add the ID field if it exists
          if (uiField.includes('Country') && !frozen[uiField + 'Id']) {
            frozen[uiField + 'Id'] = true
          }
          if (uiField.includes('State') && !frozen[uiField + 'Id']) {
            frozen[uiField + 'Id'] = true
          }
          if (uiField.includes('City') && !frozen[uiField + 'Id']) {
            frozen[uiField + 'Id'] = true
          }
        }
      }
    })
    setFrozenFields(frozen)
  }, [tpoConfig, studentFormData?.studentPersonalProfile, studentFormData?.admin])

  useEffect(() => {
    form.setFieldsValue({
      caste: studentFormData?.studentPersonalProfile?.caste,
      religion: studentFormData?.studentPersonalProfile?.religion,
      preferredJobLocation:
        studentFormData?.studentPersonalProfile?.preferredJobLocation,
    })
    form.setFieldsValue({
      isAnyWhere: studentFormData?.studentPersonalProfile?.isAnywhere,
    })
    setIsAnyWhere(studentFormData?.studentPersonalProfile?.isAnywhere)

    setCasteValue(studentFormData?.studentPersonalProfile?.caste)
    setReligionValue(studentFormData?.studentPersonalProfile?.religion)

    let hobbiesList = []
    studentFormData?.studentPersonalProfile?.hobbies?.map((data, index) => {
      let type = 'hobbie_' + index
      form.setFieldsValue({
        [type]: data,
      })
      hobbiesList.push({
        component: Hobbies,
        type: type,
      })
    })
    setHobbies(
      studentFormData?.studentPersonalProfile?.hobbies?.length > 0
        ? hobbiesList
        : hobbies
    )

    let languageList = []
    studentFormData?.studentPersonalProfile?.languages?.map((data, index) => {
      let type = 'language_' + index
      form.setFieldsValue({
        [type]: data,
      })
      languageList.push({
        component: Languages,
        type: type,
      })
    })
    setLanguages(
      studentFormData?.studentPersonalProfile?.languages?.length > 0
        ? languageList
        : languages
    )
    const locationPreffered =
      studentFormData?.studentPersonalProfile?.preferredJobLocation || []

    const mappedCities = locationPreffered
      .filter(city => city?.id || city?.city_id || city?.state_id)
      .map(city => ({
        value: city?.id ?? city?.city_id ?? city?.state_id,
        label: city?.name ?? city?.city_name ?? city?.state_name,
        payload: city,
      }))

    setLocations(mappedCities)
    setInititalLocations(mappedCities)
  }, [studentFormData])
  useEffect(() => {
    getHobbbieList()
    getLanguageList()
  }, [hobbies, languages])
  const languagesHandler = (isAdd, isDelete, deleteVlaue) => {
    let arr = []
    arr.push({
      component: Languages,
      type: 'language_' + languages?.length,
    })
    if (isAdd) {
      setIsUpdateButtonEnabled(false)
      setLanguages(lang => lang.concat(arr))
    }

    if (isDelete) {
      setIsUpdateButtonEnabled(false)
      let languageList = languages?.filter(data => data?.type !== deleteVlaue)
      setLanguages(languageList)
      form.setFieldsValue({
        [deleteVlaue]: '',
      })
    }
  }

  const hobbiesHandler = (isAdd, isDelete, deleteVlaue) => {
    let arr = []
    arr.push({
      component: Hobbies,
      type: 'hobbie_' + hobbies?.length,
    })
    if (isAdd) {
      setIsUpdateButtonEnabled(false)
      setHobbies(hob => hob.concat(arr))
    }
    if (isDelete) {
      setIsUpdateButtonEnabled(false)
      let hobbieList = hobbies?.filter(data => data?.type !== deleteVlaue)
      setHobbies(hobbieList)
      form.setFieldsValue({
        [deleteVlaue]: '',
      })
    }
    getHobbbieList()
  }

  const getHobbbieList = () => {
    let hobbie = getKeyValuePair('hobbie')
    setHobbieList(Object.entries(hobbie))
  }
  const getLanguageList = () => {
    let language = getKeyValuePair('language')
    setLanguageList(Object.entries(language))
  }

  const getKeyValuePair = value => {
    let formObject = form.getFieldsValue()
    return Object.keys(formObject)
      .filter(key => key.includes(value))
      .reduce((cur, key) => {
        return Object.assign(cur, { [key]: formObject[key] })
      }, {})
  }

  const onCountryChange = (data, option) => {
    setIsUpdateButtonEnabled(false)
    form.setFieldsValue({
      permCountry: data,
      permState: '',
      permCity: '',
      permCountryId: option?.option?._id,
      permStateId: '',
      permCityId: '',
    })
    formRef.current.setFields([
      {
        name: 'permCountry',
        errors: [],
      },
    ])
    setPermCountryName(data)
    setPermCountryId(option?.option?._id)
    setPermStateName('')
    setPermStateId('')
    setPermCityName('')
    setSearchCountry('')
    getStateData(option?.option?._id, true)
    getListOfCountries()
    isSameAddress && onCurentCountryChange(data, option)
  }

  const onCurentCountryChange = (data, option) => {
    setIsUpdateButtonEnabled(false)
    form.setFieldsValue({
      corrCountry: data,
      corrState: '',
      corrCity: '',
      corrCountryId: option?.option?._id,
      corrStateId: '',
      corrCityId: '',
    })
    formRef.current.setFields([
      {
        name: 'corrCountry',
        errors: [],
      },
    ])
    setTemCountryName(data)
    setTemCountryId(option?.option?._id)
    setTemStateId('')
    setTemStateName('')
    setTemCityName('')
    setSearchCountry('')
    if (!isSameAddress) {
      getStateData(option?.option?._id, false)
      getListOfCountries()
    }
  }

  const onStateChange = (data, option) => {
    setIsUpdateButtonEnabled(false)
    form.setFieldsValue({
      permState: data,
      permCity: '',
      permStateId: option?.option?._id,
      permCityId: '',
    })
    formRef.current.setFields([
      {
        name: 'permState',
        errors: [],
      },
    ])
    setPermStateName(data)
    setPermStateId(option?.option?._id)
    setPermCityName('')
    getStateData(permCountryId, true)
    getCityData(permCountryId, option?.option?._id, true)
    isSameAddress && onCurrentStateChange(data, option)
  }

  const isAnyWhereOnChange = data => {
    setIsUpdateButtonEnabled(false)
    setIsAnyWhere(data?.target?.checked)
    form.setFieldsValue({
      isAnyWhere: data?.target?.checked,
    })
  }

  const onCurrentStateChange = (data, option) => {
    setIsUpdateButtonEnabled(false)
    form.setFieldsValue({
      corrState: data,
      corrCity: '',
      corrStateId: option?.option?._id,
      corrCityId: '',
    })
    formRef.current.setFields([
      {
        name: 'corrState',
        errors: [],
      },
    ])
    setTemStateId(option?.option?._id)
    setTemStateName(data)
    setTemCityName('')
    if (!isSameAddress) {
      getStateData(temCountryId, false)
      getCityData(temCountryId, option?.option?._id, false)
    }
  }

  const onCityChange = (data, option) => {
    setIsUpdateButtonEnabled(false)
    form.setFieldsValue({ permCity: data, permCityId: option?.option?._id })
    formRef.current.setFields([
      {
        name: 'permCity',
        errors: [],
      },
    ])
    setPermCityName(data)
    setPermCityId(option?.option?._id)
    getCityData(permCountryId, permStateId, true)
    isSameAddress && onCurrentCityChange(data, option)
  }
  const onCurrentCityChange = (data, option) => {
    setIsUpdateButtonEnabled(false)
    form.setFieldsValue({ corrCity: data, corrCityId: option?.option?._id })
    formRef.current.setFields([
      {
        name: 'corrCity',
        errors: [],
      },
    ])
    setTemCityName(data)
    setTemCityId(option?.option?._id)
    !isSameAddress && getCityData(temCountryId, temStateId, false)
  }

  const physicallyOnchange = data => {
    setIsUpdateButtonEnabled(false)
    if (data === false) {
      form.setFieldsValue({ physicalChallenge: '' })
    }
    setIsPhysicallyChallenged(data)
  }
  const sameAddressOnChange = data => {
    setIsUpdateButtonEnabled(false)
    setIsSameAddress(data?.target?.checked)
    if (data?.target?.checked) {
      setTemCountryName(permCountryName)
      setTemStateName(permStateName)
      setTemCityName(permCityName)
      setTemCountryId(permCountryId)
      setTemStateId(permStateId)
      setTemCityId(permCityId)
      form.setFieldsValue({
        corrAddrLine1: permAddressLine1,
        corrAddrLine2: permAddressLine2,
        corrCountry: permCountryName,
        corrState: permStateName,
        corrCity: permCityName,
        corrCountryId: permCountryId,
        corrStateId: permStateId,
        corrCityId: permCityId,
        corrPostCode: permPinCode,
      })
    } else {
      setTemCountryName('')
      setTemStateName('')
      setTemCityName('')
      setTemStateList([])
      setTemCityList([])
      form.setFieldsValue({
        corrAddrLine1: '',
        corrAddrLine2: '',
        corrCountry: '',
        corrState: '',
        corrCountryId: '',
        corrStateId: '',
        corrCityId: '',
        corrPostCode: '',
        corrCity: '',
      })
    }
  }
  const isCorporateMasterExist = (value, name) => {
    return !form.getFieldValue(name + 'Id')
  }
  const submitHandler = async values => {
    const date = moment(values?.dob, 'DD/MM/YYYY', true)
    const date1 = moment(values?.dob, 'YYYY-MM-DD', true)
    const isNotFutureDate = moment(values?.dob, 'DD/MM/YYYY').isSameOrBefore(
      moment(),
      'day'
    )
    let dateValidation = false
    if (!values?.dob || (!date?.isValid() && !date1?.isValid())) {
      form.setFieldsValue({ dob: null })
      dateValidation = true
      setError('Please enter a valid date of birth (DD/MM/YYYY)')
    } else if (!isNotFutureDate && !date1?.isValid()) {
      form.setFieldsValue({ dob: null })
      dateValidation = true
      setError('Date Cannot be Future Date')
    } else {
      setError('')
    }
    let hobbies = []
    let languages = []

    hobbieList.forEach(([key, values]) => {
      hobbies.push(values)
    })
    languageList.forEach(([key, values]) => {
      languages.push(values)
    })

    let payload = {
        checkForApproval: true,
        checkDeleteSection: ['studentPersonalProfile'],
      admin: {
        ...studentFormData?.admin,
        gender: values?.gender,
        dob: values?.dob 
            ? (moment(values?.dob, 'YYYY-MM-DD', true).isValid()
                ? moment(values?.dob, 'YYYY-MM-DD').format('YYYY-MM-DD')
                : moment(values?.dob, 'DD/MM/YYYY', true).isValid()
                  ? moment(values?.dob, 'DD/MM/YYYY').format('YYYY-MM-DD')
                  : values?.dob)
            : values?.dob,
        countryCode: studentFormData?.admin?.countryCode,
      },
      student: studentFormData?.student,
      degreeStreamMap: !studentFormData?.student?.isExpCandidate
        ? {
            degreeId: studentFormData?.currentCourse?.degreeId,
            streamId: studentFormData?.currentCourse?.streamId,
          }
        : {},
      studentPersonalProfile: {
        ...studentFormData?.studentPersonalProfile,
        caste: values?.caste || '',
        religion: values?.religion || '',
        isAnywhere: values?.isAnyWhere,

        preferredJobLocation:
          values?.preferredJobLocation?.map(item => item.payload ?? item) || [],
        languages: languages || [],
        hobbies: hobbies,
        secondaryEmail: values?.secondaryEmail || null,
        permAddrLine1: values?.permAddrLine1,
        permAddrLine2: values?.permAddrLine2,
        permCity: values?.permCity,
        permState: values?.permState,
        permPostCode: values?.permPostCode,
        permCountry: values?.permCountry,
        permCityId: values?.permCityId,
        permStateId: values?.permStateId,
        permCountryId: values?.permCountryId,
        isSameCorresponding: isSameAddress,
        corrAddrLine1: values?.corrAddrLine1,
        corrAddrLine2: values?.corrAddrLine2,
        corrCity: values?.corrCity,
        corrState: values?.corrState,
        corrPostCode: values?.corrPostCode,
        corrCountry: values?.corrCountry,
        corrCityId: values?.corrCityId,
        corrStateId: values?.corrStateId,
        corrCountryId: values?.corrCountryId,
        isPhysicallyChallenged: isPhysicallyChallenged,
        physicalChallenge: values?.physicalChallenge,
        extraCurriculars: extraCurriculars || '',
      },
    }
    payload = {
      ...payload,
      currentCourse: !studentFormData?.student?.isExpCandidate
        ? {
            ...studentFormData?.currentCourse,
            marks: studentFormData?.currentCourse?.marks ?? 0,
          }
        : {},
      education: studentFormData?.education,
      resume: studentFormData?.resume,
    }
    if (payload?.currentCourse?.specialisationId === null) {
      delete payload?.currentCourse?.specialisationId
    }
    if (payload?.currentCourse?.skills === null) {
      delete payload?.currentCourse?.skills
    }
    if (payload?.studentPersonalProfile?.registraionNo) {
      delete payload?.studentPersonalProfile?.registraionNo
    }

    if (payload?.education && Array.isArray(payload.education)) {
      payload.education.forEach((item, index) => {
        if (item?.skills === null) delete payload.education[index]?.skills
        if (item?.markSheetUrl === null)
          delete payload.education[index]?.markSheetUrl
        if (item?.degreeStreamMapId === null)
          delete payload.education[index]?.degreeStreamMapId
      })
    }

    if (payload?.currentCourse?.degreeStreamMapId === null) {
      delete payload?.currentCourse?.degreeStreamMapId
    }

    if (!dateValidation) {
      let response = await updateStudentData(payload)
      const data = response?.response?.data

      if (
        data?.student?.currentState != 4 &&
        data?.student?.educationProfile?.length > 0 &&
        (data?.isAnywhere || data?.preferredJobLocation?.length > 0)
      ) {
        //await dispatch(updateCurrentState(data?.student?.id, 4))
      }
      if (response?.success === true) {
        if (data?.studentPersonalProfile) {
          dispatch(setResumeData({
            ...studentFormData,
            studentPersonalProfile: data.studentPersonalProfile
          }))
          setExtraCurriculars(data.studentPersonalProfile.extraCurriculars || '')
        }
        if (getPendingData) {
          getPendingData().catch(err => console.error('getPendingData error:', err))
        }
        // Check if data was sent to pending or main table based on response
        const responseData = response?.response?.data
        const wentToPending = responseData?.pendingData || responseData?.approvalRequired || responseData?.message?.includes('approval')
        
        if (wentToPending) {
          SuccessMessage('Sent for Approval!')
        } else {
          SuccessMessage('Updated Successfully!')
        }
        setdrawerStatus(false)
      } else {
        ErrorMessage(response?.response?.data?.message)
      }
    }
  }
  let getCountryData = async (search, initial = false) => {
    setLoadingCountry(true)
    let list = await getListOfCountries(search, true, setLoadingCountry)
    setLoadingCountry(false)
    if (initial && search) {
      await updateCountryData(list)
    }
    return list || []
  }
  const handleInputChange = e => {
    setIsUpdateButtonEnabled(false)
  }

  const locationHandler = (selectedValues, selectedOptions) => {
    const selectedPayloads = selectedOptions?.map(item => item.option)

    form.setFieldsValue({
      preferredJobLocation: selectedPayloads,
    })
    setIsUpdateButtonEnabled(false)
    setLocations(selectedPayloads)
  }
  const handlePinCode = e => {
    if (isSameAddress) {
      form.setFieldValue('permPostCode', e.target.value)
      form.setFieldValue('corrPostCode', e.target.value)
    } else {
      form.setFieldValue(e.target.id, e.target.value)
    }
  }
  const content = () => {
    return (
      <Form
        onFinish={submitHandler}
        scrollToFirstError
        id={'additionalForm'}
        form={form}
        ref={formRef}
        layout="vertical"
      >
        <Control flexStart top="10px" column>
          <LabelWithPending isPending={pendingFields.gender !== undefined}>Gender *</LabelWithPending>
          <AntdSelect
            placeholder="Select"
            OptionData={genderOptions}
            name={'gender'}
            rules={[
              {
                validator: async (_, value) => {
                  if (!gender) {
                    return Promise.reject(new Error('Please select a gender!'))
                  }
                  return Promise.resolve()
                },
              },
            ]}
            onChange={onChangeGender}
            valueParam="value"
            nameParam="name"
            value={gender}
            disabled={frozenFields.gender}
          />
        </Control>
        <>
          <FormItem name="dob">
            <Control flexStart top="20px" column>
              <LabelWithPending isPending={pendingFields.dob !== undefined}>Date of birth *</LabelWithPending>

              <Date
                format={dateFormat}
                placeholder={dateFormat}
                value={date ? moment(date) : null}
                onChange={handleDateChange}
               // defaultValue={ studentFormData?.admin?.dob ? moment(studentFormData?.admin?.dob) : null}
                disabledDate={d => !d || d.isAfter(moment())}
                disabled={frozenFields.dob}
              //  value={form.getFieldValue(['dob']) === null ? undefined : date}
              />
            </Control>
          </FormItem>
          {error && <p style={{ color: 'red' }}>{error}</p>}
        </>

        <Control flexStart top="25px" column>
          <LabelWithPending isPending={pendingFields.secondaryEmail !== undefined}>Secondary Email Address</LabelWithPending>
          <AntdInput
            placeholder="eg:harry@yahoo.com"
            name={'secondaryEmail'}
            rules={[
              {
                required: false,
              },
              () => ({
                validator(_, value) {
                  let isValid = IsValidEmail(value)
                  if (!isValid) {
                    if (value === undefined || value === '') {
                      return Promise.resolve()
                    } else {
                      return Promise.reject(
                        new Error(`Please Enter Valid Email`)
                      )
                    }
                  }

                  return Promise.resolve()
                },
              }),
            ]}
            onChange={handleInputChange}
            disabled={frozenFields.secondaryEmail}
          />
        </Control>
        {/* <Control spaceBetween top="20px" gap="15px"> */}
        {/* <Control column>
            <Label>Caste</Label>
            <AntdSelect
              OptionData={casteList}
              name={'caste'}
              onChange={onChangeCaste}
              valueParam="name"
              nameParam="name"
              value={casteValue}
              placeholder="Eg. General"
              width={'255px'}
            />
          </Control>
          <Control column>
            <Label>Religion</Label>
            <AntdSelect
              OptionData={religionList}
              name={'religion'}
              onChange={onChangeReligion}
              valueParam="name"
              nameParam="name"
              value={religionValue}
              placeholder="Eg. Hindu"
              dropdownMatchSelectWidth={false}
              width={'255px'}
            />
          </Control> */}
        {/* </Control> */}
        {/* <Control column top="20px">
          <Label>Are You Physically Challenged:</Label>

          <RadioGroup
            onChange={({ target }) => physicallyOnchange(target.value)}
            defaultValue={isPhysicallyChallenged}
          >
            {RadioOptions?.map((item, index) => (
              <Radio
                key={index + 'options'}
                border={true}
                label={item?.label}
                value={item?.value}
              />
            ))}
          </RadioGroup>
          {isPhysicallyChallenged && (
            <Control top="20px">
              <AntdInput
                placeholder="Physical Challenge"
                name={'physicalChallenge'}
              />
            </Control>
          )}
        </Control> */}
        <Control top="40px">
          <Heading>Languages</Heading>
        </Control>
        <Control column top="10px">
          {!!languages &&
            languages?.map((obj, index) => {
              return (
                <obj.component
                  key={obj?.type}
                  type={obj?.type}
                  onRemove={() => languagesHandler(false, true, obj?.type)}
                  languageList={languageList}
                  getLanguageList={getLanguageList}
                  setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                />
              )
            })}
        </Control>
        <Control
          onClick={() => languagesHandler(true, false)}
          style={{ cursor: 'pointer' }}
          gap="10px"
          alignCenter
          width={'30%'}
        >
          <AdjustIcon>
            <AddIcon />
          </AdjustIcon>
          <Text>Add Languages</Text>
        </Control>
        <Control flexStart top="10px" column>
          <FormItem name={'isAnyWhere'} />

          <Control>
            <Heading>Preferred Job Locations</Heading>
          </Control>
          <Control column top="10px">
            <LabelWithPending isPending={pendingFields.preferredJobLocation !== undefined}>Where do you want to work *</LabelWithPending>
            <Control column bottom="10px">
              <Checkbox
                label={'Anywhere'}
                onChange={isAnyWhereOnChange}
                value={isAnyWhere}
              ></Checkbox>
            </Control>

            {!isAnyWhere && (loadingCity ? (
              <Spin size="small" style={{ marginTop: '10px', display: 'flex', justifyContent: 'flex-start' }} />
            ) : (
            <AntdSelect
                placeholder="Eg.Chennai"
                name={'preferredJobLocation'}
                rules={[
                  {
                    required: true,
                    message: 'Please enter preferred job location!',
                  },
                ]}
                OptionData={allOptions}
                filterOption={false}
                onChange={locationHandler}
                value={locations}
                mode="multiple"
                maxTagCount={3}
                valueParam="value"
                nameParam="label"
                showSearch={true}
                loading={loadingCity}
                onSearch={data => {
                  setSearchValue(data)
                  getPerfCityData(data)
                }}
                iskey={true}
                onDropdownVisibleChange={open => {
                  if (open) {
                    getPerfCityData('')
                  } else {
                    form.setFieldsValue({
                      preferredJobLocation: locations,
                    })
                  }

                  const sortedInit = [...inititalLocations].sort((a, b) =>
                    a.label.localeCompare(b.label)
                  )
                  const sortedLoc = [...locations].sort((a, b) =>
                    a.label.localeCompare(b.label)
                  )

                  const isSame =
                    JSON.stringify(sortedInit.map(i => i.value)) ===
                    JSON.stringify(sortedLoc.map(i => i.value))

                  setIsUpdateButtonEnabled(isSame)
                }}
              />
            ))}
          </Control>
        </Control>

        {/* <Control top="40px">
          <Heading>Hobbies</Heading>
        </Control>
        <Control column top="10px">
          <Label>What do you like?</Label>
          {!!hobbies &&
            hobbies.map((obj, index) => {
              return (
                <obj.component
                  key={obj}
                  type={obj?.type}
                  onRemove={() => hobbiesHandler(false, true, obj?.type)}
                  hobbieList={hobbieList}
                  getHobbbieList={getHobbbieList}
                  setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                />
              )
            })}
        </Control>
        <Control
          onClick={() => hobbiesHandler(true, false)}
          style={{ cursor: 'pointer' }}
          gap="10px"
          alignCenter
          width={'30%'}
        >
          <AdjustIcon>
            <AddIcon />
          </AdjustIcon>
          <Text>Add Hobbies</Text>
        </Control>
        */}
        <Control top="40px">
          <LabelWithPending isPending={pendingFields.extraCurriculars !== undefined}>
            <Heading>Extracurricular Activities</Heading>
          </LabelWithPending>
        </Control>
        <Control>
          <FormItem
            name={'extraCurriculars'}
            rules={[
              {
                validator: async (_, value) => {
                  if (countRichTextCharacters(extraCurriculars) > 1000) {
                    return Promise.reject(
                      new Error('Maximum 1000 Character allowed!')
                    )
                  }
                  return Promise.resolve()
                },
              },
            ]}
          >
            <RichEditor
              value={extraCurriculars}
              onChange={onChangeExtraCurriculars}
              disabled={frozenFields.extraCurriculars}
            />
            {'Characters: ' +
              countRichTextCharacters(extraCurriculars) +
              ' / 1000'}
          </FormItem>
        </Control> 
        <Address
          form={form}
          loading={loading}
          loadingCountry={loadingCountry}
          loadingState={loadingState}
          loadingCity={loadingCity}
          setLoadingCountry={setLoadingCountry}
          setLoadingState={setLoadingState}
          setLoadingCity={setLoadingCity}
          setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
          countryList={countryList}
          stateList={permStateList || []}
          cityList={permCityList || []}
          onCountryChange={onCountryChange}
          onStateChange={onStateChange}
          onCityChange={onCityChange}
          heading={'Permanent Address'}
          address1Name={'permAddrLine1'}
          address2Name={'permAddrLine2'}
          countryName={'permCountry'}
          stateName={'permState'}
          cityName={'permCity'}
          pincode={'permPostCode'}
          secondAddress1Name={'corrAddrLine1'}
          secondAddress2Name={'corrAddrLine2'}
          secondPincode={'corrPostCode'}
          isTemAddress={false}
          isSameAddress={isSameAddress}
          countryValue={permCountryName}
          stateValue={permStateName}
          cityValue={permCityName}
          countryId={permCountryId}
          getListOfCountries={getCountryData}
          stateId={permStateId}
          cityId={permCityId}
          getStateData={getStateData}
          getCityData={getCityData}
          setSearchCountry={setSearchCountry}
          frozenFields={frozenFields}
          setPermCountryName={setPermCountryName}
          isCorporateMasterExist={isCorporateMasterExist}
          setStateName={setPermStateName}
          setStateId={setPermStateId}
          setCountryName={setPermCountryName}
          setCountryId={setPermCountryId}
          setCityName={setPermCityName}
          setCityId={setPermCityId}
          errorNote={errorNote}
          setErrorNote={setErrorNote}
          handlePinCode={handlePinCode}
          pendingFields={pendingFields}
        />
        <Control top="35px" spaceBetween>
          <Heading>Current Address</Heading>
          <Checkbox
            label={'Same as permanent address'}
            onChange={sameAddressOnChange}
            value={isSameAddress}
            disabled={
              frozenFields?.permCountry || frozenFields?.permState || frozenFields?.permCity ||
              frozenFields?.corrCountry || frozenFields?.corrState || frozenFields?.corrCity
            }
          />
        </Control>
        <Address
          form={form}
          loading={loading}
          loadingCountry={loadingCountry}
          loadingState={loadingState}
          loadingCity={loadingCity}
          setLoadingCountry={setLoadingCountry}
          setLoadingState={setLoadingState}
          setLoadingCity={setLoadingCity}
          setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
          countryList={countryList}
          stateList={temStateList || []}
          cityList={temCityList || []}
          onCountryChange={onCurentCountryChange}
          onStateChange={onCurrentStateChange}
          onCityChange={onCurrentCityChange}
          heading={null}
          address1Name={'corrAddrLine1'}
          address2Name={'corrAddrLine2'}
          countryName={'corrCountry'}
          stateName={'corrState'}
          cityName={'corrCity'}
          frozenFields={frozenFields}
          pincode={'corrPostCode'}
          isTemAddress={true}
          isSameAddress={isSameAddress}
          countryValue={temCountryName}
          stateValue={temStateName}
          cityValue={temCityName}
          countryId={temCountryId}
          stateId={temStateId}
          cityId={temCityId}
          getStateData={getStateData}
          getCityData={getCityData}
          setSearchCountry={setSearchCountry}
          getListOfCountries={getCountryData}
          isCorporateMasterExist={isCorporateMasterExist}
          setStateName={setTemStateName}
          setStateId={setTemStateId}
          setCountryName={setTemCountryName}
          setCountryId={setTemCountryId}
          setCityName={setTemCityName}
          setCityId={setTemCityId}
          errorNote={errorNote}
          setErrorNote={setErrorNote}
          handlePinCode={handlePinCode}
          pendingFields={pendingFields}
        />
      </Form>
    )
  }
  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setdrawerStatus(false)
          }}
        />
        <Button.Primary
          form={'additionalForm'}
          htmlType="submit"
          text={'Update'}
          disabled={isUpdateButtonEnabled}
        />
      </FooterFlex>
    )
  }
  return (
    <StyledDrawer
      width="675px"
      title={'Additional Info'}
      placement="right"
      closable={true}
      onClose={() => setdrawerStatus(false)}
      visible={drawerStatus}
      content={content()}
      footer={footer()}
    />
  )
}

export default AdditionDrawer
